import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { BaseControl, Form, FormPage, SubFormularioControl, TypeChecker } from '../../../shared';
import { CommonModule, NgComponentOutlet } from '@angular/common';
import { AuthFormularioService } from '../../../services/database/authFormulario.service';
import { FormCreatorService } from '../../../services';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormViewer } from '../../../../public-api';
import { CustomTitle } from '../../custom-work/other/custom-title/custom-title.component';
import { DynamicForm } from '../../../shared/classes/dynamic-form';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-sub-formulario-control',
  standalone: true,
  imports: [CommonModule,
    ReactiveFormsModule,
    ButtonModule, CardModule, StepsModule, TranslateModule, CustomTitle
  ],
  providers: [FormCreatorService],
  template: `
  @if(formId){
  <div *ngIf="this.fc.Pages.length > 1" class="mb-2 w-full">
    <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
  </div>
  <div class="form-panel-preview w-full">
    <CustomTitle *ngIf="fc.Form.title" [title]="fc.Form.title" 
    styleClass="font-principal font-20 title-blue border-round ml-1 font-medium px-5 py-3 w-full bg-gray-200" />
    <div class="content formgrid p-fluid">
      <form #form="ngForm" [formGroup]="fc.FormGroup" class="w-full">
        <ng-container *ngIf="fc.activePage" class="w-full">
          <ng-container *ngIf="formSectionPageComponent" class="w-full">
            <ng-container *ngComponentOutlet="formSectionPageComponent; 
              inputs: { page: fc.activePage, pageIndex: fc.activeIndex, formGroup: fc.getPageFormGroup(fc.activePage.name), isDesigner: false }"
              class="w-full"></ng-container>
          </ng-container>
        </ng-container>
      </form>
    </div>
    <div class="footer">
      <div>
        <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
          icon="pi pi-angle-left"></p-button>
      </div>
      <div>
        <p-button *ngIf="!isLastPage" [label]="'form.button.siguiente' | translate" (onClick)="nextPage()"
          icon="pi pi-angle-right" iconPos="right"></p-button>
      </div>
    </div>
  </div>
    @if(typeChecker.isSubFormulario(control)){
      @if(!viewAnswerMode){
        <div class="w-full">
          <button pButton type="button" *ngIf="control.removeDeleteBtn !== true"
            [label]="'msg.eliminarSubformulario' | translate" 
            icon="pi pi-trash" class="p-button-sm w-full p-button-outlined p-button-danger mb-2"
            (click)="onRemoveSubform()"></button>
        </div>
      }
    }
  }
  `,
  styles: `
    :host {
      display: contents;
    }
  ` 
})
export class SubFormularioControlComponent extends BaseFormViewer implements OnInit, OnDestroy {

  @Input() control !: BaseControl<any>;
  @Input() index !: number;
  @Input() radicado ?: string;
  @Output() formLoaded = new EventEmitter<DynamicForm>();
  @Output() onRemoveForm = new EventEmitter<number>();

  private _currentFormId !: number|undefined;
  private _currentFormVersion !: number|undefined;
  private _formIdSub !: Subscription;

  formSectionPageComponent: any = null;
  componentInputs !: any;

  get viewAnswerMode(): boolean {
    return this.fc.viewAnswerMode;
  }

  get formId(): number | undefined {
    if (this.typeChecker.isSubFormulario(this.control)) {
      return this.control.formId;
    }
    return undefined;
  }

  constructor(private _fs: AuthFormularioService, public override fc: FormCreatorService) { 
    super(fc);
  }

  ngOnDestroy(): void {
    this._formIdSub?.unsubscribe();    
  }

  ngOnInit(): void {
    this.loadFormSectionPageComponent();

    this._formIdSub?.unsubscribe();
    if (this.typeChecker.isSubFormulario(this.control)) {
      this._formIdSub = this.control.formId$.subscribe(formId => {
        if (formId) {
          this.getFormulario();
        }
      });
    }
  }

  private async loadFormSectionPageComponent(): Promise<void> {
    const { FormSectionPageComponent } = await import('../../form-builder/form-section-page/form-section-page.component');
    this.formSectionPageComponent = FormSectionPageComponent;
  }

  getFormulario() {
    if (this.typeChecker.isSubFormulario(this.control) && this.control.formId && this.control.version) {
      // Avoid reloading the same form
      if (this._currentFormId === this.control.formId) {
        return;
      }
      this._fs.findByIdAndVersion(this.control.formId, this.control.version).subscribe({
        next: (response: Form) => {
          if (this.typeChecker.isSubFormulario(this.control)) {
            this._currentFormId = this.control.formId;
            this._currentFormVersion = this.control.version;
            this.fc.loadForm(response, this.radicado); 
            this.formLoaded.emit(this.fc.Form);                 
          }
        }
      });
    }
  }

  onRemoveSubform() {
    this.onRemoveForm.emit(this.index);
  }
}
